export const CART_REQUEST_TIMEOUT_MS = 30000;

// Bound cart work, including body parsing, without retrying mutations. An
// interrupted write may already be committed: refresh the cart before retrying.
export const withCartRequestDeadline = (request, { signal, timeoutMs = CART_REQUEST_TIMEOUT_MS } = {}) => {
  const controller = new AbortController();
  let timer;
  let rejectInterrupted;
  const interrupted = new Promise((_, reject) => { rejectInterrupted = reject; });
  const abort = () => {
    const error = new Error("Cart request cancelled.");
    error.name = "AbortError";
    rejectInterrupted(error);
    controller.abort();
  };
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) abort();
  timer = setTimeout(() => {
    const error = new Error("This is taking longer than expected. Refresh your cart before trying again.");
    error.code = "CART_REQUEST_TIMEOUT";
    rejectInterrupted(error);
    controller.abort();
  }, timeoutMs);
  return Promise.race([
    interrupted,
    Promise.resolve().then(() => {
      if (controller.signal.aborted) throw Object.assign(new Error("Cart request cancelled."), { name: "AbortError" });
      return request({ signal: controller.signal });
    }),
  ]).finally(() => {
    clearTimeout(timer);
    signal?.removeEventListener("abort", abort);
  });
};
